import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { IStore } from "../../../../redux/store";
import BunkerFuelTable from "./_elements/BunkerFuelTable";
import vdmDashboardActions from "redux/app/vdmdashboard/actions";
import { VDM_DASHBOARD_TABS } from "redux/app/vdmdashboard/@types";
import vdmDashboardSelectors from "redux/app/vdmdashboard/selectors";
import EthaneFuelTable from "./_elements/EthaneFuelTable";
import FuelTable from "./_elements/FuelTable";
import BunkerTankRobsTables from "./_elements/BunkerTankRobsTables";

interface ExpandedParams {
	[expanderItem: string]: boolean;
}

type OwnProps = {
	vesselId: string;
};

type VesselDashboardBunkerProps = PropsFromRedux & OwnProps;
function VesselDashboardBunker(props: VesselDashboardBunkerProps) {
	const { bunkerData, jobToLoadDashboardContent,fuelTableData, bunkerTankRobs } = props;
	const [isExpanded, setIsExpanded] = useState<ExpandedParams>({
		hfo: true,
		lsmgo: false,
		ethane: false,
	});


	if (jobToLoadDashboardContent.isLoading) {
		return (
			<div className="mt-12 flex items-center justify-center">
				<div className="border-4 border-gray-200 border-t-4 border-t-blue-500 rounded-full w-12 h-12 animate-spin"></div>
			</div>
		);
	}

	return (
		<>
			{fuelTableData ? <FuelTable fuelTableData={fuelTableData} /> : null}
			{bunkerTankRobs ? <BunkerTankRobsTables bunkerTankRobs={bunkerTankRobs} /> : null}

			{/* INFO: Not part of phase-1 */}
			<div className="mt-4 hidden">
				<div className="bg-white rounded-md shadow-sm border border-gray-200 overflow-hidden">
					<div
						className="px-4 py-3 bg-gray-50 border-b border-gray-200 flex items-center justify-between cursor-pointer"
						onClick={() =>
							setIsExpanded({ ...isExpanded, hfo: !isExpanded?.hfo })
						}
					>
						<h3 className="text-base font-medium text-gray-900">HFO</h3>
						{isExpanded?.hfo ? (
							<span className="bp3-icon bp3-icon-chevron-up text-gray-600" />
						) : (
							<span className="bp3-icon bp3-icon-chevron-down text-gray-600" />
						)}
					</div>

					<div
						className={`
					transition-all
					ease-in-out
					duration-300
					overflow-hidden
					${
						isExpanded?.hfo && bunkerData?.hfo
							? "max-h-[1000px] opacity-100"
							: "max-h-0 opacity-0"
					}
    			`}
					>
						{isExpanded?.hfo && bunkerData?.hfo && (
							<BunkerFuelTable fuelType="HFO" tableData={bunkerData?.hfo} />
						)}
					</div>
				</div>

				<div className="bg-white rounded-md shadow-sm border border-gray-200 overflow-hidden mt-4">
					<div
						className="px-4 py-3 bg-gray-50 border-b border-gray-200 flex items-center justify-between cursor-pointer"
						onClick={() =>
							setIsExpanded({ ...isExpanded, lsmgo: !isExpanded?.lsmgo })
						}
					>
						<h3 className="text-base font-medium text-gray-900">LSMGO</h3>
						{isExpanded?.lsmgo ? (
							<span className="bp3-icon bp3-icon-chevron-up text-gray-600" />
						) : (
							<span className="bp3-icon bp3-icon-chevron-down text-gray-600" />
						)}
					</div>

					<div
						className={`
					transition-all
					ease-in-out
					duration-300
					overflow-hidden
					${
						isExpanded?.lsmgo && bunkerData?.lsmgo
							? "max-h-[1000px] opacity-100"
							: "max-h-0 opacity-0"
					}
    			`}
					>
						{isExpanded?.lsmgo && bunkerData?.lsmgo && (
							<BunkerFuelTable fuelType="LSMGO" tableData={bunkerData?.lsmgo} />
						)}
					</div>
				</div>

				<div className="bg-white rounded-md shadow-sm border border-gray-200 overflow-hidden mt-4">
					<div
						className="px-4 py-3 bg-gray-50 border-b border-gray-200 flex items-center justify-between cursor-pointer"
						onClick={() =>
							setIsExpanded({ ...isExpanded, ethane: !isExpanded?.ethane })
						}
					>
						<h3 className="text-base font-medium text-gray-900">Ethane</h3>
						{isExpanded?.ethane ? (
							<span className="bp3-icon bp3-icon-chevron-up text-gray-600" />
						) : (
							<span className="bp3-icon bp3-icon-chevron-down text-gray-600" />
						)}
					</div>

					<div
						className={`
					transition-all
					ease-in-out
					duration-300
					overflow-hidden
					${
						isExpanded?.ethane && bunkerData?.ethane
							? "max-h-[1000px] opacity-100"
							: "max-h-0 opacity-0"
					}
    			`}
					>
						{isExpanded?.ethane && bunkerData?.ethane && (
							<EthaneFuelTable tableData={bunkerData?.ethane} />
						)}
					</div>
				</div>
			</div>
		</>
	);
}
function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const vdmDashboardStore = vdmDashboardSelectors._getStore(store);
	const selectedVDMTab =
		vdmDashboardSelectors.getVDMActiveTab(vdmDashboardStore);
	const bunkerData = vdmDashboardSelectors.getVDMBunkerData(vdmDashboardStore);
	const jobToLoadDashboardContent =
		vdmDashboardSelectors.getJobToLoadVDMDashboardContent(vdmDashboardStore);
	const dashboardContent =
		vdmDashboardSelectors?.getVDMDashboardContent(vdmDashboardStore);
	const fuelTableData = dashboardContent?.bunkerRobs;
	const bunkerTankRobs = dashboardContent?.bunkerTankRobs;

	return {
		selectedVDMTab,
		bunkerData,
		jobToLoadDashboardContent,
		fuelTableData,
		bunkerTankRobs
	};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {
		loadBunkerTab: (vesselId: string) => {
			return dispatch(vdmDashboardActions.commands.vdmBunkerTabLoad(vesselId));
		},
	};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(VesselDashboardBunker);
